import React, { useState } from "react";
import { Link } from "gatsby"
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import styled from "@emotion/styled";
import { css} from "@emotion/core";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch, SearchBox, Configure, connectHits, Highlight, Pagination, connectRefinementList, ClearRefinements} from 'react-instantsearch-dom';
import 'instantsearch.css/themes/algolia.css';
import Layout from "../components/layout";
import Section1 from "../sections/the-ladybosses-section1";
import Section3 from "../sections/the-ladybosses-section3";
import Section4 from "../sections/the-ladybosses-section4";
import SEO from "../components/seo"
import { isMentorImageValid } from "../utils/mentor-image";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import "../components/MenuSlide.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";


const SectionTitle = styled.div`
  color: ${props => props.theme.colors.primary_violet}; 
  margin-top:18px;
  margin-bottom:30px;
  width:100%;
  text-align:left;
  font: bold 28px/28px Roboto;
`

const SectionImage = styled.img`
  margin-top: 45px;
`

const FAFilter = styled(FontAwesomeIcon)`
  font-size: 16px;
  color: ${props => props.theme.colors.white};
`

const LadybossMenuTitle = styled.span`
  display:block;
  float:left;
  font: bold 16px/28px Roboto;
  margin-bottom:10px;
  @media(max-width:768px) {
    margin-bottom:10px;
  }
  @media(max-width:576px) {
    float: none;
  }
`

const ButtonFill = styled(Button)`
    height: 47px;
    width:100%;
    color: ${props => props.theme.buttons.primary_button_violet.normal.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.normal.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_violet.normal.border_color} !important;
    font: 16px/20px Roboto;
    transition: 0.25s ease-out;
    &:hover {
    color: ${props => props.theme.buttons.primary_button_violet.hovered.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.hovered.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_violet.hovered.border_color} !important;
    box-shadow: 0px 3px 20px ${props => props.theme.colors.gray_shadow} !important;
    @media(min-width:1199px){
        margin-top:-3px;
        margin-bottom:3px;
    }
    }
    &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.buttons.primary_button_violet.pressed.color} !important;
    background-color: ${props => props.theme.buttons.primary_button_violet.pressed.background_color} !important;
    border-color: ${props => props.theme.buttons.primary_button_violet.pressed.border_color} !important;
    box-shadow: none !important;
    @media(min-width:1199px){
        margin-top:-3px;
        margin-bottom:3px;
    }
    }
`

const LadybossPagination = styled(Pagination)`
  .ais-Pagination-link {
    width:33.98px;
    height:38px;
    padding-top:8px;
    text-align:center;
    font: 1rem Roboto;
    border: 1px solid ${props => props.theme.colors.gray_border};
    border-radius:0;
    color:${props => props.theme.colors.primary_violet};
    @media(min-width:768px) {
      margin-right:8px;
      border-radius:0.25rem;
    }
    &:hover, &:focus, &.focus, &:active, &.active  {
      color:${props => props.theme.colors.white};
      background-color:${props => props.theme.colors.primary_violet}; 
      border-color:${props => props.theme.colors.primary_violet}; 
    }
  }
  .ais-Pagination-item--previousPage .ais-Pagination-link {
    border-left: 1px solid ${props => props.theme.colors.gray_border};
    border-top-left-radius:.25rem;
    border-bottom-left-radius:.25rem;
    padding-right:70px;
    @media(min-width:768px) {
      border: 1px solid ${props => props.theme.colors.gray_border};
      border-radius:.25rem;
      padding-right:70px;
      margin-right:8px;
    }
  }
  .ais-Pagination-item--nextPage .ais-Pagination-link {
    border-top-right-radius:.25rem;
    border-bottom-right-radius:.25rem;
    padding-right:45px;
    @media(min-width:768px) {
      border: 1px solid ${props => props.theme.colors.gray_border};
      border-radius:.25rem;
      padding-right:45px;
    }
  }
  .ais-Pagination-link--selected {
    color:${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.gray_dark} !important;
    border-color: ${props => props.theme.colors.gray_dark} !important;
  }
  .ais-Pagination-item + .ais-Pagination-item {
    margin-left:0;
  }
  @media(max-width:767px) {
    justify-content: center !important;
  }
  @media(min-width:768px) {
    float:left;
  }
`

const SecondSectionContainer = styled(Container)`
  margin-top:34px;
  margin-bottom:100px;
  @media(max-width:767px) {
    margin-top:15px;
    margin-bottom:20px;
  }
`


const SecondSectionCard = styled(Button)`
  padding:0;
  color: ${props => props.theme.colors.gray_dark};
  background-color: ${props => props.theme.colors.white};
  border-color: ${props => props.theme.colors.gray_border};
  font: 16px/22px Roboto;
  transition: 0.25s ease-out;
  @media(max-width:767px) {
    width:100%;
  }
  &:hover {
    color: ${props => props.theme.colors.gray_dark};
    background-color: ${props => props.theme.colors.white};
    border-color: ${props => props.theme.colors.gray_border};
    box-shadow: 0px 3px 5px ${props => props.theme.buttons.secondary_small_button_violet.hovered.shadow} !important;
    cursor: pointer;
  }
  &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.colors.gray_dark};
    background-color: ${props => props.theme.colors.white};
    border-color: ${props => props.theme.colors.gray_border};
    box-shadow: none;
    cursor: pointer;
  }
`
const SecondSectionCardBody = styled(Card.Body)`
  text-align:center;
  padding:9px;
  overflow:hidden;
  @media(min-width:768px) {
    height:220px;
    word-break: break-word;
  }
  @media(min-width:992px) {
    height:140px;
  }
`
const SecondSectionCardTitle = styled(Card.Title)`
  font: Bold 16px/22px Roboto;
  margin-bottom:10px;
`
const SecondSectionCardSubtitle = styled(Card.Subtitle)`
  font: 12px/16px Roboto;
`
const LadyBossHighlight = styled(Highlight)`
  .ais-Highlight-highlighted, .ais-Snippet-highlighted {
    background-color: ${props => props.theme.colors.accent_yellow};
  }
`

const Hits = ({ hits }) => (
  <Row css={css`@media(min-width:1300px){margin-right: -80px !important; 
    margin-left: -80px !important;}`}>
    {hits.map(hit => (
      <Col md="2" css={css`margin-top:15px;`}>
        {/* <Link
          to={"/the-ladybosses/" + hit.name.trim().replace(/ /gi, '-').toLowerCase()} 
          asModal
        > */}
        <Link
          to={"/the-ladybosses/" + hit.name.trim().replace(/ /gi, '-').toLowerCase()} 
        >
          
          <SecondSectionCard variant="light">
            <Card.Img alt={"WomenWorks Ladyboss - " + hit.name} variant="top" 
                src={isMentorImageValid(hit.photoLink) ? hit.photoLink : "/ladybosses/"+ hit.name.trim().replace(/ /gi, '-').toLowerCase()+".jpg"}
                css={ css` ${isMentorImageValid(hit.photoLink)? `filter: grayscale(100%);` : ``} 
                object-fit:cover;
                @media(max-width:540px) {
                  width:100%;
                  height: calc(383/540*100vw);
                  max-width: 508px;
                  max-height: 383px;
                }
                @media(min-width:541px) {
                  width:100%;
                  height: calc(767/767*100vw);
                  max-width: 508px;
                  max-height: 383px;
                }
                @media(min-width:768px) {
                  width:calc(200/1440*100vw);
                  height: calc(150/1440*100vw);
                  max-width: 200px;
                  max-height: 150px;
                }`}
                />
            <SecondSectionCardBody>
              <SecondSectionCardTitle>
                <LadyBossHighlight attribute="name" hit={hit} />
              </SecondSectionCardTitle>
              <SecondSectionCardSubtitle>
                <LadyBossHighlight attribute="title" hit={hit} />
              </SecondSectionCardSubtitle>
            </SecondSectionCardBody>
          </SecondSectionCard>

        </Link>
      </Col>
    ))}
  </Row>
);

const LadybossHits = styled(connectHits(Hits))`
  .ais-Hits-item {
    border: none;
    box-shadow: none;
  }
`

const FilterDropdown = ({
  items,
  isFromSearch,
  refine,
  searchForItems,
  createURL,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown((prevState) => !prevState);
  };

  const [selectedValue, setSelectedValue] = useState('');
  const handleSelectValue = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    console.log("selectedValue:");
    console.log(JSON.stringify(value));
    console.log(selectedValue);

  };

  return(
    <div className="menu-dropdown" css={css` position: relative;
    `}>
      <button onClick={toggleDropdown} css={css`
            border : 1px solid #8D589B;
            background-color: #fff;
            border-radius: 5px;
            font: 16px/16px Roboto;
            color: #55626F; 
            margin-top:-8px;
            margin-left:5px;
            height:47px;
            width:85px;
          `}>
        Cities  
        <span className="arrow" css={css`
            color: #8D589B; 
            padding-left:10px;
          `}>{showDropdown ? '▲' : '▼'}</span>
      </button>
      {showDropdown && (
          <div className="dropdown-content" css={css`
            border : 1px solid #8D589B;
            border-radius: 5px;
            width : 250px;
            position: absolute;
            top: 100%;
            left: 68px;
            z-index: 999;
            background-color: #fff;
            padding: 20px;
            @media(max-width:1200px) {
              left: 6px;
            }
          `}>
            <Row css={css`margin-left:0px; margin-right:0px;`}>
              <input
                type="search"
                onChange={event => searchForItems(event.currentTarget.value)}
                css={css`
                border : 1px solid #8D589B;
                width : 100%;
                padding: 5px;
                color: #8D589B;
                border-radius: 5px;
                margin-bottom: 10px;
              `}
              />
              </Row>
              
              <Row css={css`margin-left:0px; margin-right:0px; @media(max-width:768px) {
                max-height: 85px;
                overflow: hidden;
              }`}>
              {items.map(item => (
                <li style={{backgroundColor:item.isRefined ? '#8D589B' : '#FFFFFF'}}
                // className={item.isRefined ? 'item-refined' : 'item-not-refined'}
                css={css`    display: inline-block;
              padding: 5px 6px;
              font: 16px/16px Roboto;
              border: 2px solid #8D589B !important;
              text-align: center;
              white-space: nowrap;
              vertical-align: baseline;
              border-radius: 99px;
              margin-bottom:8px;
              margin-right:5px;
              @media(max-width:768px) {
                padding: 8px 11px;
              }
              `} 
              key={item.label}>
                <a
                  href={createURL(item.value)}
                  // style={{ fontWeight: item.isRefined ? 'bold' : '' }}
                  style={{ color: item.isRefined ? '#FFFFFF' : '#8D589B' }}
                  // className={item.isRefined ? 'label-refined' : 'label-not-refined'}
                  onClick={event => {
                    event.preventDefault();
                    refine(item.value);
                    handleSelectValue(event);
                  }}
                  value = {selectedValue}
                  css={css`
                  text-decoration: none !important;
                  .ais-Highlight-highlighted, .ais-Snippet-highlighted {
                    background-color: #F6DE9D;
                  }
                  `}
                >
                  {isFromSearch ? (
                    <Highlight attribute="label" hit={item} />
                  ) : (
                    item.label
                  )}
                </a>
              </li>

              
            ))}
              </Row>
          </div>
      )}
    </div>
  );
}
const CustomFilterDropdown = connectRefinementList(FilterDropdown);

const RefinementListCustom = ({
  items,
  isFromSearch,
  refine,
  searchForItems,
  createURL,
}) => {
  return(
    <div>
            <Row css={css`margin-left:0px; margin-right:0px;`}>
              <input
                type="search"
                onChange={event => searchForItems(event.currentTarget.value)}
                css={css`
                border : 1px solid #8D589B;
                width : 100%;
                padding: 5px;
                color: #8D589B;
                border-radius: 5px;
                margin-bottom: 10px;
              `}
              />
              </Row>
              
              <Row css={css`margin-left:0px; margin-right:0px; @media(max-width:768px) {
                max-height: 85px;
                overflow: hidden;
              }`}>
              {items.map(item => (
                <li style={{backgroundColor:item.isRefined ? '#8D589B' : '#FFFFFF'}}
                // className={item.isRefined ? 'item-refined' : 'item-not-refined'}
                css={css`    display: inline-block;
              padding: 5px 6px;
              font: 16px/16px Roboto;
              border: 2px solid #8D589B !important;
              text-align: center;
              white-space: nowrap;
              vertical-align: baseline;
              border-radius: 99px;
              margin-bottom:8px;
              margin-right:5px;
              @media(max-width:768px) {
                padding: 8px 11px;
              }
              `} 
              key={item.label}>
                <a
                  href={createURL(item.value)}
                  // style={{ fontWeight: item.isRefined ? 'bold' : '' }}
                  style={{ color: item.isRefined ? '#FFFFFF' : '#8D589B' }}
                  // className={item.isRefined ? 'label-refined' : 'label-not-refined'}
                  onClick={event => {
                    event.preventDefault();
                    refine(item.value);
                    // handleSelectValue(event);
                  }}
                  css={css`
                  text-decoration: none !important;
                  .ais-Highlight-highlighted, .ais-Snippet-highlighted {
                    background-color: #F6DE9D;
                  }
                  `}
                >
                  {isFromSearch ? (
                    <Highlight attribute="label" hit={item} />
                  ) : (
                    item.label
                  )}
                </a>
              </li>

              
            ))}
              </Row></div>
);}

const CustomRefinementList = connectRefinementList(RefinementListCustom);

const RefinementListIntrest = ({
  items,
  isFromSearch,
  refine,
  createURL,
}) => {
  return(
    <div>
              <Row css={css`margin-left:0px; margin-right:0px;padding-left: 5px; 
              @media(max-width:768px) {
                max-height: 85px;
                overflow: hidden;
                padding-left: 0px;
              }
              @media(min-width:1200px) {
                max-width: 476px;
                height: 82px;
              }
              `}>
              {items.map(item => (
                <li style={{backgroundColor:item.isRefined ? '#8D589B' : '#FFFFFF'}}
                css={css`    display: inline-block;
              padding: 8px 11px;
              font: 16px/16px Roboto;
              border: 2px solid #8D589B !important;
              text-align: center;
              white-space: nowrap;
              vertical-align: baseline;
              border-radius: 99px;
              margin-bottom:8px;
              margin-right:5px;
              @media(max-width:768px) {
                padding: 8px 11px;
              }
              `} 
              key={item.label}>
                <a
                  href={createURL(item.value)}
                  style={{ color: item.isRefined ? '#FFFFFF' : '#8D589B' }}
                  onClick={event => {
                    event.preventDefault();
                    refine(item.value);
                  }}
                  css={css`
                  text-decoration: none !important;
                  .ais-Highlight-highlighted, .ais-Snippet-highlighted {
                    background-color: #F6DE9D;
                  }
                  `}
                >
                  {isFromSearch ? (
                    <Highlight attribute="label" hit={item} />
                  ) : (
                    item.label
                  )}
                </a>
              </li>

              
            ))}
              </Row></div>
);}

const CustomRefinementListInterest = connectRefinementList(RefinementListIntrest);

const AlgoliaKey = require("../utils/algolia-credentials")
const tooltip = (
  <Tooltip id="tooltip" arrowProps={{ className: 'custom-tooltip-arrow' }} css={css`
  .tooltip-inner {
    background-color: #4E4F58;
    color: #FFFFFF;
    font: 12px/16px Roboto;
    width:320px !important;
  }
  .custom-tooltip-arrow::before {
    border-top-color: #4E4F58;
  }
  
  `}>
    Try typing words important to you like yoga, swimming, hiking, entrepreneur, founders, finance, mother, etc
  </Tooltip>
);

const BottomMenuSlide = () => {
  const [showMenu, setShowMenu] = useState(false);

  const handleClose = () => {
    setShowMenu(false);
  };

  return (
    <div>
      <ButtonFill onClick={() => setShowMenu(!showMenu)} css={css`margin-top:-8px;`}>
      <FAFilter icon={faFilter} css={css`margin-right: 7px;`}/>Filter
      </ButtonFill >

      <div className={`menu-content ${showMenu ? 'show' : ''}`} css={css` padding: 24px 40px 24px 40px;`}>
        
        <Row css={css` font: bold 24px/28px Roboto; margin-bottom:20px`}>
          Filter
        </Row>
        <Row>
        <LadybossMenuTitle>
                Interests
                </LadybossMenuTitle>
        </Row>
        <Row>
        {/* <LadybossMenu attribute="hobbiesInterests" limit="8"/> */}
        <CustomRefinementListInterest attribute="hobbiesInterests" limit="8"/>
        </Row>
        <Row css={css`margin-top:15px`}>
        <LadybossMenuTitle>
                  Location
                </LadybossMenuTitle>
        </Row>
        <Row css={css`margin-top:-8px`}>
        <CustomRefinementList attribute="city" searchable="true"/>
        </Row >
        <Row css={css`margin-top:15px`}>
        
        <Col xs="6" css={css`padding-left:0px`}>
        <ClearRefinements translations={{ reset: 'Reset' }} 
        css={css`
        .ais-ClearRefinements-button{
          margin-top:10px;
          height: 47px;
          width:100%;
          font: 16px/22px Roboto; 
          background-color: transparent !important;
          border: 1px solid #8D589B !important;
          color: #8D589B !important; 
          transition: 0.25s ease-out;
          &:hover {
            color: #FFFFFF !important;
            background-color: #8D589B !important;
            border-color: #8D589B !important;
            box-shadow: 0px 3px 20px #00000033 !important;
            @media (min-width: 1199px) {
              margin-top: -3px;
              margin-bottom: 3px;
            }
          }
          &:focus, &.focus, &:active, &.active {
            color: #FFFFFF !important;
            background-color: #8D589B !important;
            border-color: #8D589B  !important;
            box-shadow: none !important;
            @media (min-width: 1199px) {
              margin-top: -3px;
              margin-bottom: 3px;
            }
          }
        }
        `}
        />
        </Col>
        <Col xs="6" css={css`padding-right:0px`}>
        <ButtonFill onClick={handleClose} css={css`margin-top:10px;`}>
          Apply
        </ButtonFill >
        </Col>
        
        </Row>
        

                
                
                
                
      </div>
    </div>
  );
};

export default class TheLadybosses extends React.Component {

  render() {
    const searchClient = algoliasearch(
      AlgoliaKey.appId,
      AlgoliaKey.searchKey,
    )

    let valueRefinement = "";

    if (typeof window !== `undefined`) {  
      let params = new URLSearchParams(document.location.search);
      valueRefinement = params.get("mentorconnects");
      console.log("activekey:", valueRefinement);
    }

    return (
      <Layout 
        LogoColor={props => props.theme.colors.secondary_green} 
        HeaderMenuColor={props => props.theme.colors.gray_dark} 
        firstSectionBGColor={props => props.theme.colors.white}

        //button
        HeaderButtonColor={props => props.theme.buttons.primary_small_button_yellow_gray.normal.color} 
        HeaderButtonBorder={props => props.theme.buttons.primary_small_button_yellow_gray.normal.border_color} 
        HeaderButtonBackground={props => props.theme.buttons.primary_small_button_yellow_gray.normal.background_color}
        
        HeaderButtonColorHover={props => props.theme.buttons.primary_small_button_yellow_gray.hovered.color}
        HeaderButtonBorderHover={props => props.theme.buttons.primary_small_button_yellow_gray.hovered.border_color} 
        HeaderButtonBackgroundHover={props => props.theme.buttons.primary_small_button_yellow_gray.hovered.background_color}

        HeaderButtonColorPressed={props => props.theme.buttons.primary_small_button_yellow_gray.pressed.color}
        HeaderButtonBorderPressed={props => props.theme.buttons.primary_small_button_yellow_gray.pressed.border_color} 
        HeaderButtonBackgroundPressed={props => props.theme.buttons.primary_small_button_yellow_gray.pressed.background_color}
      >
        <SEO title={"The Ladybosses"} description={"Get mentored and connected to Indonesia’s inspiring professionals through WomenWorks"} />
        <Section1></Section1>

        <InstantSearch searchClient={searchClient} indexName="Mentors">
          <Container css={css`@media(min-width:768px) {display: none;}`}>
            <SectionImage src="/page-the-ladybosses-section2-img1.png"/> 
            <SectionTitle>Find like-minded friends and professional connections!</SectionTitle>
              <Row css={css`margin:0px`}>
                  <Col css={css`
                    max-width: 55px;
                    padding-left: 0px;
                    `}>
                  <LadybossMenuTitle css={css``}>
                    Search
                  </LadybossMenuTitle>
                  </Col>
                  
                  <Col css={css`
                    padding-left: 0px;
                    @media(max-width:767px) {
                    }
                    `}>
                      <OverlayTrigger placement="bottom" overlay={tooltip} css={css`
                    `}>
                      <SearchBox css={css`
                      .ais-SearchBox-submit, .ais-SearchBox-reset {
                        z-index:0;
                        margin-top:-4px;
                      }
                      .ais-SearchBox-input{
                        height:47px; 
                        width:100%;
                        border : 1px solid #8D589B;
                        border-radius: 5px;
                        font: 16px/16px Roboto;
                        color: #898989; 
                        margin-top:-8px;
                        margin-left:5px;
                        padding-right:0px;
                        padding-left:18px;
                      }
                    `}
                        defaultRefinement={valueRefinement}
                        translations={{
                        placeholder: 'Search',
                      }}/>
                    </OverlayTrigger>
                  </Col>
                  <BottomMenuSlide/>
                </Row>
                <Row css={css`margin-left:0px;margin-right:0px`}>
                      <div css={css`
                      font: 14px/16px Roboto;
                      color: #4E4F58;
                      font-weight: 400;
                      margin-top:8px;
                    `}>
                      Search for mentors by names, or other topics such as hobbies, interests, industry, company, university and more!
                      </div>
                </Row>
            
          </Container>
          <Container css={css`
          @media(max-width:767px) {
            display: none;
          }`}>
          <SectionImage src="/page-the-ladybosses-section2-img1.png"/> 
          <SectionTitle>Find like-minded friends and professional connections!</SectionTitle>
          <Row css={css`margin-top:25px;text-align:center;`}>
              <Col xs="12" md="6" css={css`text-align:left;width:fit-content;`}>
                <LadybossMenuTitle>
                Interests
                </LadybossMenuTitle>
                <CustomRefinementListInterest attribute="hobbiesInterests" limit="8"/>
              </Col>
              <Col xs="12" md="2" css={css`text-align:left;width:fit-content;
              @media(max-width:767px) {
                display:none;
              }
              `}>
                <LadybossMenuTitle>
                  Location
                </LadybossMenuTitle>
                {/* <CustomRefinementList attribute="city"
                  searchable="true"/> */}
                  <CustomFilterDropdown attribute="city" limit="8"/>
              </Col>
              <Col xs="12" md="4" css={css`text-align:left;`}>
                <Row md="12" lg="6"css={css`margin:0px`}>
                  <Col css={css`
                    max-width: 55px;
                    padding-left: 0px;
                    @media(max-width:767px) {
                      display:none;
                    }
                    `}>
                  <LadybossMenuTitle css={css``}>
                    Search
                  </LadybossMenuTitle>
                  </Col>
                  
                  <Col md="12" lg="6"css={css`
                    padding-left: 0px;
                    min-width: 294px; 
                    @media(max-width:767px) {
                      margin-top: 25px;
                    }
                    @media(min-width:1200px) {
                      margin-right: -15px !important;
                      min-width: 308px;
                    }
                    `}>
                      <OverlayTrigger placement="bottom" overlay={tooltip} css={css`
                    `}>
                      <SearchBox css={css`
                      .ais-SearchBox-submit, .ais-SearchBox-reset {
                        z-index:0;
                        margin-top:-4px;
                      }
                      .ais-SearchBox-input{
                        height:47px; 
                        width:100%;
                        border : 1px solid #8D589B;
                        border-radius: 5px;
                        font: 16px/16px Roboto;
                        color: #898989; 
                        margin-top:-8px;
                        margin-left:5px;
                        padding-right:0px;
                        padding-left:18px;
                      }
                    `}
                        defaultRefinement={valueRefinement}
                        translations={{
                        placeholder: 'Search mentor’s name or other topics',
                      }}/>
                    </OverlayTrigger>
                  </Col>
                  
                    
                </Row>
                <Row css={css`margin-left:0px;margin-right:-30px`}>
                      <div css={css`
                      font: 14px/16px Roboto;
                      color: #4E4F58;
                      font-weight: 400;
                      margin-top:8px;
                      
                    `}>
                      Search for mentors by names, or other topics such as hobbies, interests, industry, company, university and more!
                      </div>
                </Row>
                    
                  
              </Col>
            </Row>
          </Container>
          
          <SecondSectionContainer>
            <Configure hitsPerPage={12} />
            <LadybossHits />
            <Col xs="12" md="6" lg="6" css={css`padding-top:35px;@media(max-width:576px){padding-top:20px;}`}>
                <LadybossPagination
                  showFirst={false} 
                  translations={{
                    previous: 'Previous',
                    next: 'Next',
                    page(currentRefinement) {
                      return currentRefinement;
                    },
                  }}
                />
            </Col>
          </SecondSectionContainer>
          
        </InstantSearch>
        

        <Section3/>
        <Section4/>
      </Layout>   
    )
  }
}
